import { OktaAuth } from '@okta/okta-auth-js';

export const oktaAuth = new OktaAuth({
  issuer: import.meta.env.VITE_OKTA_ISSUER,
  clientId: import.meta.env.VITE_OKTA_CLIENTID,
  redirectUri: import.meta.env.VITE_OKTA_BASE_REDIRECT_URI + '/login/callback',
});
